module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pageTitle', {
    attrs: {
      "title": "酒店介绍",
      "bottomExtend": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topBlock whiteBg radius"
  }, [_c('a', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.hotelInfo.HotelName))])]), _vm._v(" "), _c('p', [_c('mu-icon', {
    staticStyle: {
      "margin-right": "-10px",
      "top": "2px",
      "position": "relative"
    },
    attrs: {
      "value": "room",
      "color": "#D4D4D4",
      "size": 13
    }
  }), _vm._v("  \n      " + _vm._s(_vm.hotelInfo.Address) + "\n      "), _c('router-link', {
    staticClass: "map radius",
    attrs: {
      "to": "/search/mapbook"
    }
  }, [_vm._v("\n        地图和周边\n      ")])], 1), _vm._v(" "), _c('p', [_c('mu-icon', {
    staticStyle: {
      "margin-right": "-10px",
      "top": "2px",
      "position": "relative"
    },
    attrs: {
      "value": "call",
      "color": "#D4D4D4",
      "size": 13
    }
  }), _vm._v("  \n      "), _c('a', {
    staticStyle: {
      "color": "#999999"
    },
    attrs: {
      "href": 'tel:' + _vm.hotelInfo.Phone
    }
  }, [_vm._v(_vm._s(_vm.hotelInfo.Phone))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("酒店介绍")]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      " + _vm._s(_vm.hotelInfo.Presentation) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("酒店设施")]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_c('label', [_vm._v("提示")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.hint))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("网络")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.wifi) + _vm._s(_vm.msg.band))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("停车场")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.park))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("自助机")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.selfservicemachine))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("餐厅")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.food))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("早餐服务")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.bf))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("会议室")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.conRoom))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("洗衣服务")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.laundry))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("行李寄存")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.luggage))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("接待外宾")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.forGue))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("银行卡")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.unionPay))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("客房设施")]), _vm._v(" "), _vm._l((_vm.msg.facilities), function(fac) {
    return _c('span', {
      staticStyle: {
        "width": "auto"
      }
    }, [_vm._v(_vm._s(fac))])
  })], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fd15e08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/hotailDetail.vue
// module id = 1423
// module chunks = 18